import * as React from "react";
import cx from "classnames";
import BackButton from "../back-button";
import WithOutsideClick from "../with-outside-click";

import styles from "./sidebar.module.css";

interface IProps {
  className?: string;
  path: string;
  isOpen: boolean;
  onClose: () => any;
  children: React.ReactChild | React.ReactChild[];
}

export default function Sidebar({
  className,
  path,
  isOpen,
  onClose,
  children
}: IProps) {
  const [currentPath, setCurrentPath] = React.useState(path);

  React.useEffect(() => {
    if (path !== currentPath && isOpen) {
      onClose();
    }
    setCurrentPath(path);
  }, [path, currentPath, isOpen, onClose, setCurrentPath]);

  function onOutsideClick() {
    if (isOpen) {
      onClose();
    }
  }

  return (
    <WithOutsideClick
      onOutsideClick={onOutsideClick}
      className={cx(styles.sidebar, className, { [styles.open]: isOpen })}
    >
      <div className={styles.navbar}>
        <BackButton onClick={onClose} />
      </div>
      {children}
    </WithOutsideClick>
  );
}
